import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
import {
  IExpressPaymentMethods as IExpressPaymentMethodsServer,
  IGooglePayPaymentMethod,
} from '@wix/cashier-core/dist/src/services/PaymentMethod/types';
import { ApplePayPaymentMethod, ExpressPaymentMethods } from '../../../types/PaymentMethods';
import { mapApplePayPaymentMethodToCommon } from './applePay';
import { mapGooglePayPaymentMethodToCommon } from './googlePay';

export function getPaymentMethodsFromResponse(
  paymentMethodsResponse: IExpressPaymentMethodsServer,
): ExpressPaymentMethods {
  const pms = paymentMethodsResponse.map((pm) => {
    if (pm[PaymentMethod.ApplePay]) {
      return mapApplePayPaymentMethodToCommon(pm as ApplePayPaymentMethod);
    }
    if (pm[PaymentMethod.GooglePay]) {
      return mapGooglePayPaymentMethodToCommon(pm as IGooglePayPaymentMethod);
    }
    return pm;
  });

  return pms;
}
